import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function LoginPage() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("WELCOME BACK");
      navigate("/");
    } catch (e) {
      toast.error("LOGIN FAILED. CHECK CREDENTIALS.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#F0F0EC", overflow: "auto" }}>
      <div style={{ maxWidth: 400, width: "100%", padding: 24 }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
            <div style={{ width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <img src="https://static.prod-images.emergentagent.com/jobs/9e668205-d010-4895-90ea-66d59c7423c3/images/cb47b83b9f3104563ca8f993c7e18f3f8d0937a5d53142d582f1d1392fb0d584.png" alt="Logo" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
            </div>
            <div style={{ textAlign: "left" }}>
              <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.7rem", fontWeight: 700, letterSpacing: "0.18em", color: "#111", lineHeight: 1.2 }}>GIIST</div>
              <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.7rem", fontWeight: 700, letterSpacing: "0.18em", color: "#CC0000", lineHeight: 1.2 }}>.NET</div>
            </div>
          </div>
          <h1 style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "1.2rem", fontWeight: 700, color: "#111", margin: 0 }}>AUTHENTICATION</h1>
        </div>

        <div style={{ background: "#fff", border: "2px solid #111", padding: 32, position: "relative" }}>
          <div style={{ position: "absolute", top: -3, left: -3, width: 6, height: 6, background: "#CC0000" }} />
          <div style={{ position: "absolute", top: -3, right: -3, width: 6, height: 6, background: "#CC0000" }} />
          <div style={{ position: "absolute", bottom: -3, left: -3, width: 6, height: 6, background: "#111" }} />
          <div style={{ position: "absolute", bottom: -3, right: -3, width: 6, height: 6, background: "#111" }} />

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 20 }}>
              <label style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.6rem", letterSpacing: "0.15em", color: "#888", display: "block", marginBottom: 8 }}>EMAIL ACCESS ID</label>
              <input 
                type="email" 
                required
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="ind-input"
                autoFocus
              />
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.6rem", letterSpacing: "0.15em", color: "#888", display: "block", marginBottom: 8 }}>PASSPHRASE</label>
              <input 
                type="password" 
                required
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="ind-input"
              />
            </div>
            <button 
              type="submit" 
              disabled={loading}
              className="ind-btn-primary" 
              style={{ width: "100%", justifyContent: "center" }}
            >
              {loading ? <Loader2 size={14} className="animate-spin" /> : "INITIATE SESSION"}
            </button>
          </form>
        </div>

        <div style={{ marginTop: 24, textAlign: "center" }}>
          <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.6rem", color: "#888" }}>NEW TERMINAL? </span>
          <Link to="/register" style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.6rem", color: "#CC0000", fontWeight: 700, textDecoration: "none", marginLeft: 8 }}>
            CREATE PROFILE →
          </Link>
        </div>
      </div>
    </div>
  );
}
